import React from 'react'

const SocialIcons = () => (
    <div className="socialIcons">
        <a href="https://linkedin.com/in/zanestaggs" target="_blank" rel="noreferrer" aria-label="LinkedIn">
            <svg aria-hidden="true" version="1.1" x="0px" y="0px"width="28px" height="28px" viewBox="0 0 32 32" >
                <path fill="#444444" d="M16,0C7.2,0,0,7.2,0,16c0,8.8,7.2,16,16,16s16-7.2,16-16C32,7.2,24.8,0,16,0z M11.6,24H8.3V13.3h3.3V24z
                     M9.9,11.9C8.9,11.9,8,11,8,9.9C8,8.9,8.9,8,9.9,8c1.1,0,1.9,0.9,1.9,1.9C11.8,11,11,11.9,9.9,11.9z M24,24h-3.3v-5.2
                    c0-1.2,0-2.8-1.7-2.8c-1.7,0-2,1.3-2,2.7V24h-3.3V13.3h3.2v1.5h0c0.4-0.8,1.5-1.7,3.1-1.7c3.4,0,4,2.2,4,5.1V24z"/>
            </svg>
        </a>

        <a href="https://github.com/zanedev" target="_blank" rel="noreferrer" aria-label="GitHub">
            <svg aria-hidden="true" version="1.1" x="0px" y="0px" width="28px" height="28px" viewBox="0 0 32 32" >
                <path fill="#444444" d="M16,0C7.2,0,0,7.2,0,16c0,8.8,7.2,16,16,16s16-7.2,16-16C32,7.2,24.8,0,16,0z M18.3,22.4
                    c0,0-1.1,0.1-2.3,0.1s-2.3-0.1-2.3-0.1C10.9,22.1,8,21,8,16.2c0-1.4,0.5-2.5,1.3-3.4c-0.1-0.3-0.6-1.6,0.1-3.3c0,0,1.1-0.3,3.4,1.3
                    c1-0.3,2.1-0.4,3.1-0.4c1.1,0,2.1,0.1,3.1,0.4c2.4-1.6,3.4-1.3,3.4-1.3c0.7,1.7,0.3,3,0.1,3.3c0.8,0.9,1.3,2,1.3,3.4
                    C24,21,21.1,22.1,18.3,22.4z"/>
            </svg>
        </a>
        <a href="https://twitter.com/zanedev" target="_blank" rel="noreferrer" aria-label="Twitter">
            <svg aria-hidden="true" version="1.1" x="0px" y="0px" width="28px" height="28px" viewBox="0 0 32 32" >
                <path fill="#444444" d="M16,0C7.2,0,0,7.2,0,16c0,8.8,7.2,16,16,16s16-7.2,16-16C32,7.2,24.8,0,16,0z M22.4,12.7c0,0.1,0,0.3,0,0.4
                    c0,4.3-3.3,9.3-9.3,9.3c-1.9,0-3.6-0.5-5-1.5c0.3,0,0.5,0,0.8,0c1.5,0,3-0.5,4.1-1.4c-1.4,0-2.6-1-3.1-2.3c0.2,0,0.4,0.1,0.6,0.1
                    c0.3,0,0.6,0,0.9-0.1c-1.5-0.3-2.6-1.6-2.6-3.2c0,0,0,0,0,0c0.4,0.2,0.9,0.4,1.5,0.4c-0.9-0.6-1.5-1.6-1.5-2.7
                    c0-0.6,0.2-1.2,0.4-1.7c1.6,2,4,3.3,6.8,3.4c-0.1-0.2-0.1-0.5-0.1-0.7c0-1.8,1.5-3.3,3.3-3.3c0.9,0,1.8,0.4,2.4,1
                    c0.7-0.1,1.5-0.4,2.1-0.8c-0.2,0.8-0.8,1.4-1.4,1.8c0.7-0.1,1.3-0.3,1.9-0.5C23.6,11.7,23,12.3,22.4,12.7z"/>
            </svg>
        </a>
    </div>
)

export default SocialIcons;